import { useFormValidatedValue } from 'modules/taboola-common-frontend-modules/validations';
import { useSpendingLimitValidations } from './useSpendingLimitValidations';

export const useFormSpendingLimitValidatedValue = type => {
    const validations = useSpendingLimitValidations(type);
    return useFormValidatedValue(validations);
};
